module.exports = __webpack_public_path__ + "static/media/ico-database.f7c6bbf9.svg";